export default __webpack_public_path__ + "static/media/fatih.5708673d.jpeg";